module.exports = __webpack_public_path__ + "static/ticket_checker_help7-08e2a4831c1916c865f988b607d4e91b.jpg";